//
// Generated class IntegratorMappingValueType
//

/// <reference path="IntegratorMappingValueType_ManagedObject.ts" />

class IntegratorMappingValueType extends IntegratorMappingValueType_ManagedObject
{

}
